<template>
  <div>
    <div v-for="(item,index) in menuList" :key="index">
      <Dropdown v-if="!item.hideMenu" :key="item.id" transfer placement="right-start" @on-click="changeMenu">
        <div v-if="item.childList" class="hover-icon">
          <i :class="item.menuLogo" :style="[{'fontSize':'14px'}]"></i>
        </div>
        <DropdownMenu v-if="item.childList" slot="list">
          <template v-for="(child,i) in item.childList">
            <DropdownItem v-if="!!!child.hasChildList" :key="child.id" :name="child.href"><span style="padding-left:10px;">{{ $t(child.name) }}</span></DropdownItem>
            <Dropdown v-if="!!child.hasChildList" transfer placement="right-start">
              <DropdownItem style="width: 200px;">
                <span style="padding-left:10px;">{{ $t(child.name) }}<Icon style="position: absolute; right: 15px; top: 10px;" type="ios-arrow-forward" /></span>
              </DropdownItem>
              <DropdownMenu slot="list">
                <template v-for="(third) in child.childList">
                  <DropdownItem :key="third.id" :name="third.href">
                    <span style="padding-left:10px;">{{ $t(third.name) }}</span>
                  </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
        </DropdownMenu>
        <Tooltip v-else transfer :content="$t(item.name)" placement="right">
          <div class="hover-icon">
            <Icon :size="20" :class="item.menuLogo" :type="item.menuLogo" @click="changeMenuTool(item.href)" />
          </div>
        </Tooltip>
      </Dropdown>
    </div>
  </div>
</template>
<script>
import btnComponent from '../btnComponent/btnComponent.vue'
export default {
  name: 'MenuShrink',
  components: {
    btnComponent
  },
  props: ['menuList'],
  data () {
    return {
      btnCtrl: ''
    }
  },
  computed: {
    openTagMenu() {
      return this.$store.getters.openTagMenu
    }
  },
  watch: {
    $route(to, from) {
      this.btnCtrl = to.fullPath
      this.addItem()
    }
  },
  mounted() {
    this.btnCtrl = this.$route.path
  },
  methods: {
    changeMenu (active) {
      this.$router.push({
        path: active
      })
    },
    changeMenuTool(href) {
      this.$router.push({
        path: href
      })
    },
    // tag页签
    addItem() {
      const path = this.$route.fullPath
      const name = this.$route.meta.name
      const type = this.$route.meta.type
      const tagMenuPathArr = this.openTagMenu.tagMenuPathArr
      const tagMenuArr = this.openTagMenu.tagMenuArr
      // 要跳转的路由如果在已存在路由中不被完全匹配（除了query参数之后的部分都匹配），少了item !== path的话，点击标签导航栏会存在标签导航项互换位置的情况
      const index = tagMenuPathArr.findIndex(item => item !== path && item.split('?')[0] === path.split('?')[0])
      if (index !== -1) {
        tagMenuPathArr.splice(index, 1)
        tagMenuArr.splice(index, 1)
      }
      if (tagMenuPathArr.indexOf(path) == -1 && type == '菜单') {
        tagMenuArr.push({ path: path, name: name })
        tagMenuPathArr.push(path)
        this.$store.commit('openTagMenu', { tagMenuArr: tagMenuArr, tagMenuPathArr: tagMenuPathArr })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.hover-icon{
    width:50px;
    padding:10px 0;
    text-align: center;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/menuhide/menuHide.vue